import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChapterMark, FadeIn } from '../components/eclora/Reveal';

export default function Founder() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
    const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

    return (
        <section ref={ref} className="overflow-hidden bg-nude/15 px-6 py-20 sm:px-10 lg:py-32" data-testid="founder-section">
            <div className="mx-auto grid max-w-5xl items-center gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
                <FadeIn className="relative mx-auto w-full max-w-xs sm:max-w-sm">
                    <div aria-hidden="true" className="absolute -inset-4 rounded-t-full border border-champagne/50" />
                    <motion.div style={{ y }} className="relative overflow-hidden rounded-t-full border border-champagne/40">
                        <img
                            src="/assets/lifestyle.jpg"
                            alt="Femme contemplant un lever de soleil, une tasse Éclora à la main"
                            className="aspect-[3/4] w-full scale-110 object-cover"
                            loading="lazy"
                            data-testid="founder-photo"
                        />
                    </motion.div>
                </FadeIn>

                <div className="text-center lg:text-left">
                    <ChapterMark index="04" label="L'histoire" />
                    <FadeIn>
                        <h2 className="font-serif text-3xl font-medium leading-tight text-bordeaux sm:text-4xl lg:text-5xl">
                            Ton histoire n'est pas terminée.
                        </h2>
                    </FadeIn>
                    <FadeIn delay={0.15}>
                        <div className="mt-8 space-y-5 text-base leading-relaxed text-cacao/90">
                            <p>Mon propre Éclora n'a pas commencé par une transformation spectaculaire.</p>
                            <p>
                                Il a commencé par de petites décisions : changer certaines habitudes, revoir mes
                                routines, mieux m'organiser, prendre davantage soin de moi et surtout me demander
                                quelle femme j'avais envie de devenir.
                            </p>
                            <p>
                                Petit à petit, quelque chose a changé. Et mon entourage l'a remarqué avant même que
                                je décide d'en parler.
                            </p>
                            <p className="text-serifit text-lg text-bordeaux sm:text-xl">
                                Nous n'avons pas besoin d'attendre que notre vie change pour commencer à changer
                                notre vie.
                            </p>
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.25}>
                        <p className="mt-10 font-script text-5xl text-bordeaux" data-testid="founder-signature">Mél</p>
                        <p className="eyebrow mt-2">Fondatrice de Mon Éclora</p>
                    </FadeIn>
                </div>
            </div>
        </section>
    );
}
